import script from "./doctor.checks.vue?vue&type=script&setup=true&lang=ts"
export * from "./doctor.checks.vue?vue&type=script&setup=true&lang=ts"

import "./doctor.checks.vue?vue&type=style&index=0&id=10ed8888&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10ed8888"]])

export default __exports__